import { useEffect } from "react";
import { Outlet, /* Link,  useLocation,  */ } from "react-router-dom";

import DropDown from "./DropDown";
import VerificarUsuario from "../../helpers/usuario/verificarUsuario";

const Reporte = ({ catalogos,
    dataLoaded,
    setPrimavera1,
    setPrimavera2,
    fecha1,
    setFecha1,
    fecha2,
    setFecha2,
    idTramite,
    setIdTramite,
    idConceptoPago,
    setIdConceptoPago,
    setDia1,
    setDia2,
    setMes1,
    setMes2,
    listaEstatus,
    setListaEstatus,
    listaUsuarios,
    setListaUsuarios, }) => {

    /* console.clear(); */
    VerificarUsuario();
    /* const { pathname: path } = useLocation(); */

    const usersOptions = [];
    const estatusOptions = [];
    const { conceptoPagos, usuarios, estatusPoliza: catalogosEstatusPoliza } = catalogos;

    for (let i = 0; i < usuarios?.length ?? 0; i++) {
        usersOptions.push({
            label: `${usuarios[i].name.toUpperCase()} ${usuarios[i].lastName.toUpperCase()}`,
            id: usuarios[i].userID,
            value: usuarios[i].userID
        })
    }

    for (let i = 0; i < catalogosEstatusPoliza?.length ?? 0; i++) {
        if ([1, 3, 4].includes(catalogosEstatusPoliza[i].idEstatus)) {
            estatusOptions.push({
                label: catalogosEstatusPoliza[i].estatus.toUpperCase(),
                id: catalogosEstatusPoliza[i].idEstatus,
                value: catalogosEstatusPoliza[i].idEstatus
            });
        }
    }

    const cambiarTramite = e => {
        setIdTramite(Number(e));
        if (idTramite === 0) setIdConceptoPago(0);
        if (conceptoPagos.filter(item => item.idTramite === e).length >= 1) {
            setIdConceptoPago(Number(conceptoPagos.filter(item => item.idTramite === e)[0].idConceptoPago))
        }
    }


    const cambiarFecha1 = (e) => {
        console.log("NUEVA FECHA 1", e.target.value)
        setFecha1(e.target.value);
        setPrimavera1(e.target.value.split("-")[0])
        setMes1(e.target.value.split("-")[1])
        setDia1(e.target.value.split("-")[2])
    }

    const cambiarFecha2 = e => {
        console.log("NUEVA FECHA 2", e.target.value)
        setFecha2(e.target.value);
        setPrimavera2(e.target.value.split("-")[0])
        setMes2(e.target.value.split("-")[1]);
        setDia2(e.target.value.split("-")[2]);
    }


    useEffect(() => {
        
    }, [idTramite, idConceptoPago]);

    return (
        <div className="contenedorMain">
            <div className="formulario">
                <div className="boxRow">

                    {/* Fechsa inicial */}
                    <div className="boxColumn">
                        <label className="lblCampo">Fecha Inicial</label>
                        <div className="search-bar">
                            <input type="date"
                                value={fecha1}
                                onChange={e => cambiarFecha1(e)}
                                max={new Date(/* new Date().setFullYear(new Date().getFullYear() - 1) */).toISOString().split("T")[0]}
                            />
                        </div>
                    </div>

                    {/* Fecha Final */}
                    <div className="boxColumn">
                        <label className="lblCampo">Fecha Final</label>
                        <div className="search-bar">
                            <input type="date"
                                value={fecha2}
                                onChange={e => cambiarFecha2(e)}
                                max={new Date().toISOString().split("T")[0]}
                            />
                        </div>
                    </div>

                </div>

                <div className="boxRow">

                    {/* Trámite */}
                    <div className="boxColumn flex2">
                        <label className="lblCampo">Tramite</label>
                        <div className="search-bar">
                            <select id="selectLugarN" onChange={e => cambiarTramite(Number(e.target.value))}>
                                <option value="0">--SELECCIONAR TRÁMITE--</option>
                                {dataLoaded &&
                                    catalogos.tramites.filter(item => item.vigente === 1).map(tramite =>
                                        <option key={tramite.idTramite} value={tramite.idTramite} selected={tramite.idTramite === idTramite}>
                                            {tramite.nombre.toUpperCase().trim()}
                                        </option>
                                    )
                                }
                            </select>
                        </div>
                    </div>

                    {/* Concepto */}
                    <div className="boxColumn flex2">
                        <label className="lblCampo">Concepto</label>
                        <div className="search-bar">
                            <select id="selectLugarN" onChange={e => setIdConceptoPago(Number(e.target.value))}>
                                <option value="0">--SELECCIONAR CONCEPTO--</option>
                                {dataLoaded &&
                                    catalogos.conceptoPagos.filter(item => item.idTramite === idTramite).map(concepto =>
                                        <option key={concepto.idConceptoPago} value={concepto.idConceptoPago} title={concepto.descripcion.toUpperCase()} >
                                            {concepto.descripcion.toUpperCase().length < 70 ?
                                                concepto.descripcion.toUpperCase() :
                                                `${concepto.descripcion.toUpperCase().substring(0, 69)}...`}
                                        </option>
                                    )}
                            </select>
                        </div>
                    </div>

                </div>

                <div className="boxRow">

                    {/* Estatus de póliza */}
                    <div className="boxColumn">
                        <label className="lblCampo">Estatus de Póliza</label>
                        <DropDown
                            options={estatusOptions}
                            value={listaEstatus}
                            onChange={setListaEstatus}
                            placeholder={"SELECCIONAR ESTATUS"} />
                    </div>

                    {/* Usuarios */}
                    <div className="boxColumn">
                        <label className="lblCampo">Usuarios</label>
                        <DropDown
                            options={usersOptions}
                            value={listaUsuarios}
                            onChange={setListaUsuarios}
                            placeholder={"SELECCIONAR USUARIOS"} />
                    </div>

                </div>
            </div>

            {/* Pestañas */}
            {/* <div className="contenedor-nav boxRow noGap">
                <div>
                    <span className="espacio"></span>
                    <Link to="/reportes/poranualidad">
                        <button className={`tablinks boton-tab tab ${path === "/reportes/poranualidad" && "active"}`}>Por año</button>
                    </Link>
                    <Link to="/reportes/estatusglobal">
                        <button className={`tablinks boton-tab tab ${path === "/reportes/estatusglobal" && "active"}`}>Estatus Global</button>
                    </Link>
                </div>
            </div> */}

            <Outlet />
        </div>
    )
}

export default Reporte;